import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/t/employees/profile/$employeeId')({
  staticData: { breadcrumb: 'Employee Profile', breadcrumbKey: 'K_BREADCRUMB_EMPLOYEE_PROFILE' },
});
